// extracted by mini-css-extract-plugin
export default {"modalContainer":"ErrorModal_modalContainer__xwdkU","modal":"ErrorModal_modal__4Ef7u","titleContainer":"ErrorModal_titleContainer__9jjSV"};